module.exports = __webpack_public_path__ + "img/29_32.4232162f.png";